import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {NzMessageService, NzModalService, UploadFile} from 'ng-zorro-antd';
import { AttachmentService } from '../../../routes/jy-content/attachment/service/attachment.service';
import { FileService } from '../../../routes/jy-content/attachment/service/file.service';
import { SettingsService } from '@delon/theme';
import {CommonsService} from '@core/service/commons.service';
import { deepCopy } from '@delon/util';
import {AttachmentSrcPipe} from "@shared/pipe/attachment-src.pipe";


/**
 * 附件组件
 */
@Component({
  selector: 'file-upload',
  template: `
    <nz-upload
      [ngClass]="{'file_disabled':!isEdit}"
      [nzMultiple]="false"
      [nzListType]="listType"
      [nzShowButton]="isEdit"
      [nzDisabled]="!isEdit || isUploading"
      [nzPreview]="downLoad"
      [nzBeforeUpload]="beforeUpload"
      (nzChange)="handleChange($event)"
      nzAction="../api/file/upload"
      [nzRemove]="removeFile"
      [(nzFileList)]="innerAttach.attachFile" >
      <button nz-button [disabled]="isUploading"  *ngIf="listType!='picture-card'" type="button">
        <i class="anticon anticon-upload"></i><span>{{'shared.file-upload.update'|translate}}</span>
      </button>
      <div *ngIf="listType=='picture-card'">
        <i class="anticon anticon-plus myIcon"></i>
        <div class="ant-upload-text myUploadText">Upload</div>
      </div>
    </nz-upload>
    <span *ngIf="((!isEdit)&&(innerAttach.attachFile.length==0))">{{'shared.file-upload.noUpdate'|translate}}</span>
  `,
  styleUrls: ['./file-upload.less']
})

export class FileUploadComponent implements OnInit {
  constructor(private attachmentService:AttachmentService, private fileService:FileService,
              private commonsService:CommonsService,
              private msg:NzMessageService, private settingService:SettingsService,private modalService: NzModalService,private attachmentSrcPipe:AttachmentSrcPipe) {
    this.isEdit = false;
    this.autoUpload = true;
    this.listType = "text";
    if(!this.quantityLimit){
      this.quantityLimit = 10;
    }
    this.uploadLimit = this.settingService.app[`uploadLimit`];
    this.isUploading = false; // 是否正在上传
  }
  /**
   * 服务端url
   */
  innerAttach = {
    id: '',
    attachFile: []
  };


  ngOnInit() {

  }

  public isCustomFileType:boolean = false;//判断是否传的有fileAllowType
  ngOnChanges(changes: SimpleChanges) {
    if(changes.fileAllowType){
      if(this.fileAllowType){
        this.isCustomFileType = true;
      }else{
        this.isCustomFileType = false;
        if(this.listType === 'picture' || this.listType === 'picture-card'){
          this.fileAllowType = this.settingService.app[`allowedUploadImageExtension`];
        }else if(this.isMedia){
          this.fileAllowType = this.settingService.app[`allowedUploadMediaExtension`];
        }else{
          this.fileAllowType = this.settingService.app[`allowedUploadFileExtension`];
        }
      }
    }
    if ((changes.listType || changes.isMedia) && !this.isCustomFileType) {
      if(this.listType === 'picture' || this.listType === 'picture-card'){
        this.fileAllowType = this.settingService.app[`allowedUploadImageExtension`];
      }else if(this.isMedia){
        this.fileAllowType = this.settingService.app[`allowedUploadMediaExtension`];
      }else{
        this.fileAllowType = this.settingService.app[`allowedUploadFileExtension`];
      }
    }
  }

  /**
   * 附件
   */
  @Input()
  set attachment(attachment:any) {
    if (!(attachment)) {
      attachment = {};
    }
    if (!(attachment.attachFile)) {
      attachment.attachFile = []
    }
    this.innerAttach = attachment;
  }

  get attachment():any {
    return this.innerAttach;
  }


  /**
   * 显示样式,上传列表的内建样式， 默认text  还有图片 picture 和卡片 picture-card
   */
  @Input() listType:string;
  /**
   * 是否可编辑,默认false
   */
  @Input() isEdit:boolean;
  /**
   * 是否在添加上传文件的同时自动上传到服务器,默认true.
   * 若为否,可调用uploading方法进行手动上传
   */
  @Input() autoUpload:boolean;
  /**
   * 最大文件数量,默认最多10个
   */
  @Input() quantityLimit:number;
  /**
   * 最大文件大小(KB),若不设置,则从系统配置中去读
   */
  @Input() uploadLimit:number;
  /**
   * 可上传文件类型,若不设置,则从系统配置中去读
   */
  @Input() fileAllowType:string;
  /**
   *上传的是否为媒体文件
   * */
  @Input() isMedia:boolean;

  @Output() attachmentChange = new EventEmitter();

  @Output() isUploadingChange = new EventEmitter<boolean>();

  @Output() preview = new EventEmitter();
  isUploading = false; // 是否正在上传
  /**
   * 上传验证
   */
  beforeUpload = (file:File) => {
    this.isUploading =true;
    this.isUploadingChange.emit(this.isUploading);
    if (this.fileAllowType) {
      this.fileAllowType = this.fileAllowType.toLowerCase();
      const fileAllowType = this.fileAllowType.split(",");
      const names = file.name.split(".");
      const suffix = names[names.length - 1].toLowerCase();
      const allowType = fileAllowType.indexOf(suffix) >= 0;
      if (!allowType) {
        this.msg.error(this.commonsService.translate('shared.file-upload.notSupport'));
        this.isUploading = false;
        this.isUploadingChange.emit(this.isUploading);
        return false;
      }
    }
    if (this.uploadLimit) {
      const isLt2M = file.size / 1024 < this.uploadLimit;
      if (!isLt2M) {
        this.msg.error(this.commonsService.translate('shared.file-upload.lessThan') + this.uploadLimit +this.commonsService.translate('shared.file-upload.file'));
        this.isUploading = false;
        this.isUploadingChange.emit(this.isUploading);
        return false;
      }
    }
    if (this.quantityLimit) {
      if (this.quantityLimit != 0 && this.innerAttach.attachFile.length >= this.quantityLimit) {
        this.msg.error(this.commonsService.translate('shared.file-upload.maxUpdate') + this.quantityLimit + this.commonsService.translate('shared.file-upload.fileNum'));
        this.isUploading = false;
        this.isUploadingChange.emit(this.isUploading);
        return false;
      }
    }
    let num = this.checkAttachFile(file);
    if (!this.autoUpload) {
      // this.innerAttach.attachFile.push(file);
      if(num<0){
        this.innerAttach.attachFile.push(file);
        this.innerAttach.attachFile = deepCopy(this.innerAttach.attachFile);
      }else {
        this.commonsService.showConfirm("存在相同名字附件["+file.name+"],是否覆盖",()=>{
          this.innerAttach.attachFile.splice(num,1);
          this.innerAttach.attachFile.push(file);
          this.innerAttach.attachFile = deepCopy(this.innerAttach.attachFile);
        },()=>{
        });
      }
      this.isUploading = false;
      this.isUploadingChange.emit(this.isUploading);
      return false;
    } else{
      if(num<0){
        return true;
      }else {
        this.commonsService.showConfirm("存在相同名字附件["+file.name+"],是否覆盖",()=>{
          // this.innerAttach.attachFile.push(file);
          const formData = new FormData();
          formData.append('file', file);
          this.attachmentService.uploadFile(formData).subscribe((res) => {
            this.innerAttach.attachFile.splice(num,1);
            res.url = this.attachmentSrcPipe.transform(res.key);
            this.innerAttach.attachFile.push(res);
            this.innerAttach.attachFile = deepCopy(this.innerAttach.attachFile);
            this.isUploading = false;
            this.isUploadingChange.emit(this.isUploading);
          }, () => {
            this.isUploading = false;
            this.isUploadingChange.emit(this.isUploading);
          });
        },()=>{
          this.isUploading = false;
          this.isUploadingChange.emit(this.isUploading);
        });
        return false;
      }
    }
  };

  checkAttachFile(file:File):number{
    if(!this.innerAttach.attachFile){
      this.innerAttach.attachFile = [];
    }
    let num = -1;
    let typeNew = file.name.split(".");
    for(let i = 0;i<this.innerAttach.attachFile.length;i++){
      let type = this.innerAttach.attachFile[i].name.split(".");
      if(type[1] == typeNew[1] && type[0] == typeNew[0]){
        num = i;
        break;
      }
    }
    return num;
  }

  /**
   * 根据上传文件类型fileAllowType，生成可上传文件的后缀名
   */
  getAllowTypeSuffix(fileAllowType):string {
    let allowedTypeSuffix:string = '';
    if (fileAllowType.indexOf('image/jpeg') >= 0) {
      allowedTypeSuffix += '.jpeg '
    }
    if (fileAllowType.indexOf('application/pdf') >= 0) {
      allowedTypeSuffix += '.pdf '
    }
    if (fileAllowType.indexOf('text/plain') >= 0) {
      allowedTypeSuffix += '.txt '
    }
    if (fileAllowType.indexOf('application/vnd.ms-excel') >= 0) {
      allowedTypeSuffix += '.xls '
    }
    if (fileAllowType.indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') >= 0) {
      allowedTypeSuffix += '.xlsx '
    }
    return allowedTypeSuffix;
  }


  /**
   * 下载文件
   */
  downLoad = (file:UploadFile) => {
    let url = RegExp("https://wonly-scm-prod.oss-cn-hangzhou.aliyuncs.com/")
    if (url.exec(file.url)) {
      const  newFile= deepCopy(file);
      const url=this.encodeURITool(newFile);
      if(file.type.toLowerCase() === 'png' || file.type.toLowerCase() === 'pdf' || file.type.toLowerCase() === 'jpg' || file.type.toLowerCase() === 'jpeg' || file.type.toLowerCase() === 'gif' || file.type.toLowerCase() == 'ico'){
        let that = this;
        // ?response-content-type=application%2Foctet-stream
        this.modalService.create({
          nzTitle:'操作',
          nzContent:'当前文件支持在线预览，是否在线预览?',
          nzCancelText:'下载文件',
          nzOkText:'在线预览',
          nzOnOk:() => {
            window.open(url);
          },
          nzOnCancel:() => {
            // that.fileService.downloadIO(file);
            window.open(url+"?response-content-type=application%2Foctet-stream")
          }
        });
        return;
      }
      window.open(url+"?response-content-type=application%2Foctet-stream")
    } else {
      if(file.type.toLowerCase() === 'png' || file.type.toLowerCase() === 'pdf' || file.type.toLowerCase() === 'jpg' || file.type.toLowerCase() === 'jpeg' || file.type.toLowerCase() === 'gif' || file.type.toLowerCase() == 'ico'){
        let that = this;
        this.modalService.create({
          nzTitle:'操作',
          nzContent:'当前文件支持在线预览，是否在线预览?',
          nzCancelText:'下载文件',
          nzOkText:'在线预览',
          nzOnOk:() => {
            window.open(this.fileService.getDownloadFileFullUrl(file.key) + '&inline=true');
          },
          nzOnCancel:() => {
            that.fileService.downloadIO(file);
          }
        });
        return;
      }
      this.fileService.downloadIO(file);
    }

  };

  /**
   * 删除文件
   * @param file
   * @returns {boolean}
   */
  removeFile = (file) => {
    this.isUploading = false;
    this.isUploadingChange.emit(this.isUploading);
    if (!this.innerAttach.id && this.autoUpload && this.isEdit) {
      // this.fileService.delete(file.id).subscribe((data)=> {
      return true;
      // })
    }
    return this.isEdit;
  };

  toggle() {
    this.attachmentChange.emit(this.innerAttach);
    this.isUploadingChange.emit(this.isUploading);
  }

  // handleChange(info:any):void {
  //   if (info.file.response) {
  //     this.isUploading = false;
  //     this.isUploadingChange.emit(this.isUploading);
  //     (this.innerAttach.attachFile)[this.innerAttach.attachFile.length - 1].id = info.file.response.id;
  //     if(this.listType !== 'picture' && this.listType !== 'picture-card'){
  //       (this.innerAttach.attachFile)[this.innerAttach.attachFile.length - 1].thumbUrl = null;
  //     }
  //   }
  // }

  handleChange(info: any): void {
    if (info.type === 'success') {
      const response = info.file.response;
      this.innerAttach.attachFile = this.innerAttach.attachFile || [];

      // 构建完整的文件对象
      const newFile = {
        uid: info.file.uid,
        name: info.file.name,
        status: 'done',
        url: response.url || this.attachmentSrcPipe.transform(response.key),
        // 添加后端API下载链接
        downloadUrl: `/api/file/download/${response.key}?_allow_anonymous=true`,
        thumbUrl: (this.listType === 'picture' || this.listType === 'picture-card')
          ? response.url || this.attachmentSrcPipe.transform(response.key)
          : null,
        type: info.file.type,
        size: info.file.size,
        id: response.id,
        key: response.key
      };

      // 更新文件列表
      const existingIndex = this.innerAttach.attachFile.findIndex(f => f.uid === info.file.uid);
      if (existingIndex >= 0) {
        this.innerAttach.attachFile[existingIndex] = newFile;
      } else {
        this.innerAttach.attachFile = [...this.innerAttach.attachFile, newFile];
      }

      // 触发附件变更事件
      this.attachmentChange.emit({...this.innerAttach});
    }

    // 更新上传状态
    if (['success', 'error'].includes(info.type)) {
      this.isUploading = false;
      this.isUploadingChange.emit(this.isUploading);
    }
  }

  /**
   * 手动上传文件
   * @returns {boolean}
   */
  uploading(success):void {
    if (this.isUploading) return; // 如果正在上传则直接返回
    const formData = new FormData();
    let uploadFiles = [];
    // tslint:disable-next-line:no-any
    this.innerAttach.attachFile.forEach((file:any) => {
      if (!file.id) {
        formData.append('files[]', file);
        uploadFiles.push(file);
      }
    });
    if (uploadFiles.length > 0) {
      this.isUploading = true; // 标记为正在上传
      this.attachmentService.uploadFileMulti(formData).subscribe((data)=> {
        for (let i = 0; i < uploadFiles.length; i++) {
          uploadFiles[i].id = data[i].id;
          uploadFiles[i].key = data[i].key;
          uploadFiles[i].url = this.attachmentSrcPipe.transform(data[i].key);
          uploadFiles[i].status = 'done';
        }
        this.attachmentChange.emit(this.innerAttach);
        this.isUploading = false; // 标记为上传完成
        this.isUploadingChange.emit(this.isUploading);
        success(true);
      }, (err)=> {
        this.isUploading = false; //
        this.isUploadingChange.emit(this.isUploading);
        success(false);
      });
    } else {
      this.isUploading = false; //
      this.isUploadingChange.emit(this.isUploading);
      success(true);
    }
  }
  encodeURITool(file: UploadFile){
    // const name=file.name;
    const name = encodeURI(file.filename);
    const url = file.url;
    const namePosition = url.lastIndexOf(name);

    if (namePosition !== -1) {
      const newUrl = url.slice(0, namePosition);
      const name2 = encodeURIComponent(name);
      return newUrl + name2;
    } else {
      return url;
    }
  }

}
